import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import {newUITheme} from '../../themes/theme';
import Toast from '../../components/toast/Toast';
import AlertContainer from '../../components/alert/AlertContainer';
import {isDesktop, isMobileViewForTablet} from '../../utils/screenUtility';
/* Component routes for app level router */
import {
    DiscoverLessonsWrapper,
    MainContainer,
    MeetingsContainer,
    PrivacyPolicy,
    RegistrationContainer,
    RequestDemoPage2,
    RequestDemoSuccess,
    ResetPasswordContainer,
    SetInitialPasswordPage,
    ShareContainer,
    SigninPage,
    SignUpConfirmContainer,
    SignupRolePageStudent,
    SignupRolePageTeacher,
    SignupSelectPage,
    SocialLogin,
    StudioPage,
    TermsOfUseContainer
} from './componentLoader';
import ErrorDialog from '../../components/dialog/ErrorDialog';
import CreateContainer from '../create';
import CookiesContainer from '../cookies';
import './app.scss';
import VideoChatContainer from "../video-chat";
import {category, events, PagePath} from "../../constants/enums";
import TrialEndedDialog from "../../components/dialog/TrialEndedDialog";
import FreemiumToTrialDialog from "../../components/dialog/FreemiumToTrialDialog";
import EncouragePWADialog from "../../components/EncouragePWADialog/EncouragePWADialog";
import {observable, action} from "mobx";
import {customEvent} from "../../utils/analyticsUtil";
import {isUserFirstTime} from "../../utils/userUtility";

@inject('userStore')
@observer
class App extends Component {
    @observable pwaEvent;

    @action savePwaEvent = event => this.pwaEvent = event;
    static contextTypes = {
        router: PropTypes.object
    };

    componentDidMount() {
        this.context.router.history.listen(() => {
            window.scrollTo(0, 0);
        });
        if (isMobileViewForTablet()) {
            document.documentElement.classList.remove('tablet');
            document.documentElement.classList.add('mobile');
        }
        if (!isDesktop()) {
            window.addEventListener('beforeinstallprompt', (e) => {
                e.preventDefault();
                this.savePwaEvent(e)
            })
        }
    }

    renderContent() {
        const {location} = this.props;
        return (
            <Switch>
                <Route path={PagePath.SignUpDemo} component={RequestDemoPage2}/>
                <Route path={PagePath.SignUpSuccess} component={RequestDemoSuccess}/>
                <Route path={PagePath.SignUpStudent} component={SignupRolePageStudent}/>
                <Route path={PagePath.SignUpTeacher} component={SignupRolePageTeacher}/>
                <Route path={PagePath.SignUpSelect} component={SignupSelectPage}/>
                <Route key="ShareContainer" path={PagePath.ShareContainer} component={ShareContainer}/>
                <Route key="TermsOfUseContainer" path={PagePath.TermsOfUseContainer} component={TermsOfUseContainer}/>
                <Route key="PrivacyPolicy" path={PagePath.PrivacyPolicy} component={PrivacyPolicy}/>
                <Route key="ResetPasswordContainer" path={PagePath.ResetPasswordContainer} component={ResetPasswordContainer}/>
                <Route key="SignUpConfirmContainer" path={PagePath.SignUpConfirmContainer} component={SignUpConfirmContainer}/>
                <Route key="RegistrationContainer" path={PagePath.RegistrationContainer} component={RegistrationContainer}/>
                <Route key="CreateContainerWithId" path={PagePath.CreateContainerWithId} component={CreateContainer}/>
                <Route key="CreateContainer" exact path={PagePath.CreateContainer} component={CreateContainer}/>
                <Route key="StudioContainerWithId" path={PagePath.StudioContainerWithId} component={StudioPage}/>
                <Route key="StudioContainer" exact path={PagePath.StudioContainer} component={StudioPage}/>
                <Route key="SigninPage" path={PagePath.SigninPage} component={SigninPage}/>
                <Route key="SetInitialPasswordPage" path={PagePath.SetInitialPasswordPage} component={SetInitialPasswordPage}/>
                <Route key="SocialLogin" path={PagePath.SocialLogin} component={SocialLogin}/>
                <Route path={PagePath.MeetingsContainer} component={MeetingsContainer}/>
                <Route path={PagePath.DiscoverLessonsWrapper} component={DiscoverLessonsWrapper}/>
                <Route key="MainContainer" path={PagePath.MainContainer} component={MainContainer}/>
                <Redirect to={{...location, pathname: '/signin'}}/>
            </Switch>
        );
    }

    render() {
        return (
            <div className="app-container">
                <CookiesContainer/>
                <VideoChatContainer/>
                <MuiThemeProvider theme={createMuiTheme(newUITheme)}>
                    <div className="app-wrapper">
                        {this.renderContent()}
                        <ErrorDialog/>
                        <TrialEndedDialog/>
                        <EncouragePWADialog event={this.pwaEvent}/>
                        <FreemiumToTrialDialog/>
                    </div>
                </MuiThemeProvider>
                <Toast/>
                <AlertContainer withProgress={false}/>
            </div>
        );
    }
}

export default App;
